import * as Yup from 'yup';

export const addTrustedUserSchema = Yup.object().shape({
  phone: Yup.string()
    .required('Введите номер телефона')
    .test('phone-length', 'Введите корректный номер телефона', (value) => {
      if (!value) return false;
      const digits = value.replace(/\D/g, '');
      return digits.length === 11;
    }),
  note: Yup.string()
    .required('Введите ФИО пользователя')
    .min(2, 'ФИО должно содержать минимум 2 символа'),
  isReadOnly: Yup.boolean().required('Выберите права доступа')
});

export type AddTrustedUserFormValues = Yup.InferType<typeof addTrustedUserSchema>;
